module.exports = __webpack_public_path__ + "static/billion-dollar-whale-c5e26ef0fda50844160e520f28099846.jpg";